export enum WidgetCommonAction {
    REMOVE_WIDGET    = 'REMOVE_WIDGET',
    SECURITY_ADDED   = 'SECURITY_ADDED',
    SECURITY_REMOVED = 'SECURITY_REMOVED'
}
